<script>
import { createVaultGame } from "./vaultGameEngine";

export default {
  name: "VaultGame",
  data() {
    return {
      game: null,
      liveMessage: "VAULT 888 พร้อมเริ่มภารกิจ"
    };
  },
  mounted() {
    this.game = createVaultGame(this.$refs.gameCanvas, {
      onReward: amount => {
        this.liveMessage = `เปิดตู้สำเร็จ พบ ${amount} เครดิตตัวอย่าง`;
        this.$emit("complete", amount);
      }
    });
  },
  beforeDestroy() {
    if (this.game) this.game.destroy();
  }
};
</script>

<template>
  <main class="vault-game" aria-label="VAULT 888 เกมเปิดตู้เซฟตัวอย่าง">
    <canvas
      ref="gameCanvas"
      class="vault-game__canvas"
      tabindex="0"
      aria-label="เกม VAULT 888 แตะเริ่ม หมุนหน้าปัดตามรหัส แล้วดึงคันโยก"
    ></canvas>
    <p class="vault-game__live" aria-live="polite">{{ liveMessage }}</p>
  </main>
</template>

<style scoped lang="scss">
.vault-game {
  position: fixed;
  inset: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  min-height: 100%;
  overflow: hidden;
  background: #030706;
  overscroll-behavior: none;
  user-select: none;
  -webkit-user-select: none;
}

.vault-game__canvas {
  display: block;
  width: 100%;
  height: 100%;
  outline: none;
  cursor: grab;
  touch-action: none;
  -webkit-tap-highlight-color: transparent;

  &:active {
    cursor: grabbing;
  }
}

.vault-game__live {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>
